import { all, put, call, takeEvery } from "redux-saga/effects";
import { USER_LIST, UPDATE_PENDING_USER_LIST, USER_LIST_SUCCESS, COUNTRY_LIST, COUNTRY_LIST_SUCCESS, ROLE_LIST_SUCCESS, ROLE_LIST, REGION_LIST_SUCCESS, REGION_LIST, GET_USER_DETAILS, GET_USER_DETAILS_SUCCESS, SAVE_USER_DETAILS_SUCCESS, SAVE_USER_DETAILS, PENDING_USER_LIST, PENDING_USER_LIST_SUCCESS, UPDATE_PENDING_USER_LIST_SUCCESS, REJECTED_USER_LIST_SUCCESS, REJECTED_USER_LIST, SHOW__HIDE_LOADER, UNMOUNT_EDIT_USER_SUCCESS, UNMOUNT_EDIT_USER, SHARE_LINK_BY_EMAIL_SUCCESS, SHARE_LINK_BY_EMAIL } from '../constants/constants';
import { getUserListCall, getCountryListCall, getUserRoleListCall, getRegionListCall, getUserDetailsCall, saveUserDetailsCall, getPendingUserListCall, updatePendingUserListCall, getRejectedUserListCall, shareLinkByEmailApiCall } from '../effects/api/api.user';

function* getUserList() {
    try {
        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getUserListCall);
        yield put({ payload: response, type: USER_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getRejectedUserList() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getRejectedUserListCall);
        yield put({ payload: response, type: REJECTED_USER_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getPendingUserList() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getPendingUserListCall);
        yield put({ payload: response, type: PENDING_USER_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* updatePendingUserList(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(updatePendingUserListCall, data.payload.userId, data.payload.status);
        yield put({ payload: response, type: UPDATE_PENDING_USER_LIST_SUCCESS });

        const updateGrid = yield call(getPendingUserListCall);
        yield put({ payload: updateGrid, type: PENDING_USER_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getCountryList() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getCountryListCall);

        yield put({ payload: response, type: COUNTRY_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getRoleList() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getUserRoleListCall);
        yield put({ payload: response, type: ROLE_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getRegionList() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getRegionListCall);
        yield put({ payload: response, type: REGION_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getUserDetails(userId: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getUserDetailsCall, userId);
        yield put({ payload: response, type: GET_USER_DETAILS_SUCCESS });
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* saveUserDetails(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(saveUserDetailsCall, data);
        yield put({ payload: response, type: SAVE_USER_DETAILS_SUCCESS });
        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* unmountEditUser(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        yield put({ payload: data, type: UNMOUNT_EDIT_USER_SUCCESS });
        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* shareLinkByEmail(data: any) {
    try {
        yield put({ type: SHOW__HIDE_LOADER, payload: true });
        const response = yield call(shareLinkByEmailApiCall, data);
        if (response.data.success) {
            yield put({ payload: response.data, type: SHARE_LINK_BY_EMAIL_SUCCESS });    
        }

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

export default function* UserSaga() {
    yield all([
        takeEvery(USER_LIST, getUserList),
        takeEvery(COUNTRY_LIST, getCountryList),
        takeEvery(ROLE_LIST, getRoleList),
        takeEvery(REGION_LIST, getRegionList),
        takeEvery(GET_USER_DETAILS, getUserDetails),
        takeEvery(SAVE_USER_DETAILS, saveUserDetails),
        takeEvery(PENDING_USER_LIST, getPendingUserList),
        takeEvery(UPDATE_PENDING_USER_LIST, updatePendingUserList),
        takeEvery(REJECTED_USER_LIST, getRejectedUserList),
        takeEvery(UNMOUNT_EDIT_USER, unmountEditUser),
        takeEvery(SHARE_LINK_BY_EMAIL, shareLinkByEmail),
    ])
}


// WEBPACK FOOTER //
// ./src/saga/saga.user.tsx